import { createStore } from 'vuex'

/**************************************************
*                       JOIN                      *
**************************************************/
import joinCreateAccount from '@/store/modules/join/createAccount/state'
import joinSelfAdhesion from '@/store/modules/join/selfAdhesion/state'
/**************************************************
*                       HOME                      *
**************************************************/
import home from '@/store/modules/home/state'
/**************************************************
*                     APPROVALS                   *
**************************************************/
import approvals from '@/store/modules/approvals/state'
import approvalsPendingSignature from '@/store/modules/approvals/pendingSignature/state'
import approvalsSigned from '@/store/modules/approvals/signed/state'
import approvalsOperators from '@/store/modules/approvals/operators/state'
/**************************************************
*                  COMPANY PAYMENTS               *
**************************************************/
import companyPaymentsRequestTPA from '@/store/modules/companyPayments/requestTPA/state'
import companyPaymentsBaiPagaMerchant from '@/store/modules/companyPayments/baiPagaMerchant/state'
import companyPaymentsTPARequestsList from '@/store/modules/companyPayments/tpaRequestsList/state'
/**************************************************
*                      ACCOUNTS                   *
**************************************************/
import accountsBalancesAndMovements from '@/store/modules/accounts/balancesAndMovements/state'
import accountsPatrimony from '@/store/modules/accounts/patrimony/state'
import accountsCashflow from '@/store/modules/accounts/cashflow/state'
import accountsExtracts from '@/store/modules/accounts/extracts/state'
import accountsInvoices from '@/store/modules/accounts/invoices/state'
import accountsDetails from '@/store/modules/accounts/details/state'
import accountsWallet from '@/store/modules/accounts/wallet/state'
import accountsVisible from '@/store/modules/accounts/visible/state'
/**************************************************
*                     TRANSFERS                   *
**************************************************/
import transfersNacional from '@/store/modules/transfers/nacional/state'
import transfersInternational from '@/store/modules/transfers/international/state'
import transfersInternationalCorporate from '@/store/modules/transfers/internationalCorporate/state'
import transfersInstantBAI from '@/store/modules/transfers/instantBAI/state'
import transfersKwik from '@/store/modules/transfers/kwik/state'
import transfersRequestNaHora from '@/store/modules/transfers/requestNaHora/state'
import transfersHistoryInternational from '@/store/modules/transfers/history/international/state'
import transfersHistoryNacional from '@/store/modules/transfers/history/nacional/state'
import transfersHistoryNaHora from '@/store/modules/transfers/history/naHora/state'
import transfersPeriodic from '@/store/modules/transfers/periodic/state'
import transfersBeneficiaries from '@/store/modules/transfers/beneficiaries/state'
import transfersRequestsInternational from '@/store/modules/transfers/requests/international/state'
import transfersRequestsInternationalCorporate from '@/store/modules/transfers/requests/internationalCorporate/state'
import transfersRequestsNacionalNaHoraSent from '@/store/modules/transfers/requests/nacional/naHoraSent/state'
import transfersRequestsNacionalNaHoraReceived from '@/store/modules/transfers/requests/nacional/naHoraReceived/state'
/**************************************************
*                      PAYMENTS                   *
**************************************************/
import paymentsBAIPaga from '@/store/modules/payments/baiPaga/state'
import paymentsBatchfileConsult from '@/store/modules/payments/batchfile/consult/state'
import paymentsBatchfileNewPayment from '@/store/modules/payments/batchfile/newPayment/state'
import paymentsServices from '@/store/modules/payments/services/state'
import paymentsUnitel from '@/store/modules/payments/unitel/state'
import paymentsRupe from '@/store/modules/payments/rupe/state'
import paymentsReference from '@/store/modules/payments/reference/state'
import paymentsWallet from '@/store/modules/payments/wallet/state'
import paymentsEmisSpecial from '@/store/modules/payments/emisSpecial/state'
import paymentsVoucher from '@/store/modules/payments/voucher/state'
import paymentsRequestsBaiPaga from '@/store/modules/payments/requests/baiPaga/state'
import paymentsRequestsEKwanza from '@/store/modules/payments/requests/eKwanza/state'
import paymentsHistory from '@/store/modules/payments/history/state'
/**************************************************
*                       CARDS                     *
**************************************************/
import cardsCardlessWithdrawGenerateCode from '@/store/modules/cards/cardlessWithdraw/generateCode/state'
import cardsCardlessWithdrawMyCodes from '@/store/modules/cards/cardlessWithdraw/myCodes/state'
import cardsConsult from '@/store/modules/cards/consult/state'
import cardsAnticipatePayment from '@/store/modules/cards/anticipatePayment/state'
import cardsBlock from '@/store/modules/cards/block/state'
import cardsCancel from '@/store/modules/cards/cancel/state'
import cardsChangePayment from '@/store/modules/cards/changePayment/state'
import cardsCharge from '@/store/modules/cards/charge/state'
import cardsLimits from '@/store/modules/cards/limits/state'
import cardsTransfer from '@/store/modules/cards/transfer/state'
import cardsActivate from '@/store/modules/cards/activate/state'
import cardsRequest from '@/store/modules/cards/request/state'
import cardsConsultRequestsCancel from '@/store/modules/cards/consultRequests/cancel/state'
import cardsConsultRequestsCharge from '@/store/modules/cards/consultRequests/charge/state'
import cardsConsultRequestsNew from '@/store/modules/cards/consultRequests/new/state'
import cardsBatchfileConsult from '@/store/modules/cards/batchfile/consult/state'
import cardsBatchfileNewCharge from '@/store/modules/cards/batchfile/newCharge/state'
import cardsHistory from '@/store/modules/cards/history/state'
/**************************************************
*                      CREDITS                    *
**************************************************/
import creditsMyCredits from '@/store/modules/credits/myCredits/state'
import creditsCreditSolutions from '@/store/modules/credits/creditSolutions/state'
import creditsMyCreditsAmortization from '@/store/modules/credits/amortization/state'
/**************************************************
*                      SAVINGS                    *
**************************************************/
import savingsMySavingsPortefolio from '@/store/modules/savings/mySavings/portfolio/state'
import savingsMySavingsChargeDP from '@/store/modules/savings/mySavings/chargeDP/state'
import savingsProducts from '@/store/modules/savings/products/state'
import savingsHistoryPortfolio from '@/store/modules/savings/history/portfolio/state'
/**************************************************
*                   BANKASSURANCE                 *
**************************************************/
import bankassuranceSubscribe from '@/store/modules/bankassurance/subscribe/state'
import bankassurancePolicies from '@/store/modules/bankassurance/policies/state'
/**************************************************
*                     EXCHANGES                    *
**************************************************/
import exchanges from '@/store/modules/exchanges/state'
/**************************************************
*                     AGENCIES                    *
**************************************************/
import agencies from '@/store/modules/agencies/state'
/**************************************************
*                     FAVORITES                   *
**************************************************/
import favorites from '@/store/modules/favorites/state'
/**************************************************
*                     USER AREA                   *
**************************************************/
import userAreaProfile from '@/store/modules/userArea/profile/state'
import userAreaDefinitionsActiveChannels from '@/store/modules/userArea/definitions/activeChannels/state'
import userAreaDefinitionsPasswordChange from '@/store/modules/userArea/definitions/passwordChange/state'
import userAreaDefinitionsFriendlyUsername from '@/store/modules/userArea/definitions/friendlyUsername/state'
import userAreaDefinitionsAccountGroups from '@/store/modules/userArea/definitions/accountGroups/state'
import userAreaDefinitionsHistory from '@/store/modules/userArea/definitions/history/state'
import userAreaDefinitionsSecureAssociationEnrollment from '@/store/modules/userArea/definitions/secureAssociationEnrollment/state'
import userAreaDefinitionsNotifications from '@/store/modules/userArea/definitions/notifications/state'
/**************************************************
*              LOVS and app Transversal           *
**************************************************/
import recoverCredentials from '@/store/modules/recoverCredentials/state'
import preActiveMode from '@/store/modules/preActiveMode/state'
import shareAndSendInfo from '@/store/modules/shareAndSendInfo/state'
import menu from '@/store/modules/menu/state'
import session from '@/store/modules/session/state'
/** generic */
import * as actions from '@/store/actions'
import * as mutations from '@/store/mutations'
import * as getters from '@/store/getters'

export default createStore({
    state: {
		deviceInUse: 'Desktop', // what kind of device is in use
		mobileApp: false, // check if this is as apk
		showAlertRememberMeModal: false,
		appThemeClientType: process.env.VUE_APP_THEME_CLIENT_TYPE !== 'null' ? process.env.VUE_APP_THEME_CLIENT_TYPE : 'particular', // particular or company
		themeModeId: 'light',
		themeMode: 'light',
        statusBarStyle: 'lightContent',
		preventMobileFeatureBack: false,
		preventMobileSideModalBack: false,
		appScroll: 0,
		sideModalScroll: 0,
		footerIsBeingShowed: false,
		applyTransparencyToApp: false, // apply transparency to App to show camera related stuff
		keyboardHeight: 0,
        /* Token Challenge Modal */
		showTokenChallengeModal: false,
		tokenChallengeData: null,
		routeParams: null, // params to save when changing routes for view to receive as props
		requests: []
	},
    getters,
    mutations,
    actions,
    modules: {
		/**************************************************
		*                       JOIN                      *
		**************************************************/
		joinCreateAccount,
        joinSelfAdhesion,
		/**************************************************
		*                       HOME                      *
		**************************************************/
		home,
		/**************************************************
		*                     APPROVALS                   *
		**************************************************/
		approvals,
		approvalsPendingSignature,
		approvalsSigned,
		approvalsOperators,
		/**************************************************
		*                  COMPANY PAYMENTS               *
		**************************************************/
		companyPaymentsRequestTPA,
		companyPaymentsBaiPagaMerchant,
		companyPaymentsTPARequestsList,
		/**************************************************
		*                      ACCOUNTS                   *
		**************************************************/
		accountsBalancesAndMovements,
		accountsPatrimony,
		accountsCashflow,
		accountsExtracts,
		accountsInvoices,
		accountsDetails,
		accountsWallet,
		accountsVisible,
		/**************************************************
		*                     TRANSFERS                   *
		**************************************************/
		transfersNacional,
		transfersInternational,
        transfersInternationalCorporate,
		transfersInstantBAI,
		transfersKwik,
		transfersRequestNaHora,
		transfersHistoryInternational,
		transfersHistoryNacional,
		transfersHistoryNaHora,
		transfersPeriodic,
		transfersBeneficiaries,
		transfersRequestsInternational,
		transfersRequestsInternationalCorporate,
		transfersRequestsNacionalNaHoraSent,
		transfersRequestsNacionalNaHoraReceived,
		/**************************************************
		*                      PAYMENTS                   *
		**************************************************/
		paymentsBAIPaga,
		paymentsBatchfileConsult,
		paymentsBatchfileNewPayment,
		paymentsServices,
		paymentsUnitel,
		paymentsRupe,
		paymentsReference,
		paymentsWallet,
		paymentsEmisSpecial,
		paymentsVoucher,
		paymentsRequestsBaiPaga,
		paymentsRequestsEKwanza,
		paymentsHistory,
		/**************************************************
		*                       CARDS                     *
		**************************************************/
		cardsCardlessWithdrawGenerateCode,
		cardsCardlessWithdrawMyCodes,
		cardsConsult,
		cardsAnticipatePayment,
		cardsBlock,
		cardsCancel,
		cardsChangePayment,
		cardsCharge,
		cardsLimits,
		cardsTransfer,
		cardsActivate,
		cardsRequest,
		cardsConsultRequestsCancel,
		cardsConsultRequestsCharge,
		cardsConsultRequestsNew,
		cardsBatchfileConsult,
		cardsBatchfileNewCharge,
		cardsHistory,
		/**************************************************
		*                      CREDITS                    *
		**************************************************/
		creditsMyCredits,
		creditsCreditSolutions,
        creditsMyCreditsAmortization,
		/**************************************************
		*                      SAVINGS                    *
		**************************************************/
		savingsMySavingsPortefolio,
		savingsMySavingsChargeDP,
		savingsProducts,
		savingsHistoryPortfolio,
		/**************************************************
		*                   BANKASSURANCE                 *
		**************************************************/
		bankassuranceSubscribe,
		bankassurancePolicies,
		/**************************************************
		*                     EXCHANGES                   *
		**************************************************/
		exchanges,
		/**************************************************
		*                     AGENCIES                    *
		**************************************************/
		agencies,
		/**************************************************
		*                     FAVORITES                   *
		**************************************************/
		favorites,
		/**************************************************
		*                     USER AREA                   *
		**************************************************/
		userAreaProfile,
		userAreaDefinitionsActiveChannels,
		userAreaDefinitionsPasswordChange,
		userAreaDefinitionsFriendlyUsername,
		userAreaDefinitionsAccountGroups,
		userAreaDefinitionsHistory,
        userAreaDefinitionsSecureAssociationEnrollment,
        userAreaDefinitionsNotifications,
		/**************************************************
		*              LOVS and app Transversal           *
		**************************************************/
		recoverCredentials,
        preActiveMode,
		shareAndSendInfo,
		menu,
		session
	}
})
